import { createFileRoute, redirect } from '@tanstack/react-router';

/** Корень ведёт на рабочее место; вход проверяет layout /_app. */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});
